import type { EngineCallResult, EngineStateSnapshot } from '../../../engine_wrapper'
import { tbs } from '../../../engine/bindings/typescript/engine'

export function getEngineWasmSnapshotErrorMessage(snapshot: EngineStateSnapshot): string | null {
  const payload = snapshot.messageObject.payload
  if (payload instanceof tbs.ErrorEnvelopeT) {
    return byteStringToString(payload.message) || byteStringToString(payload.name) || `Engine error code ${payload.code}`
  }
  return null
}

export function getEngineWasmCallErrorMessage(result: EngineCallResult): string | null {
  if (result.snapshot) {
    const snapshotError = getEngineWasmSnapshotErrorMessage(result.snapshot)
    if (snapshotError) {
      return snapshotError
    }
  }
  if (result.code !== 0) {
    return `Engine error code ${result.code}`
  }
  return null
}

function byteStringToString(value: string | Uint8Array | null | undefined): string | null {
  if (value == null) {
    return null
  }
  if (typeof value === 'string') {
    return value
  }
  return new TextDecoder().decode(value)
}
